module.exports = __webpack_public_path__ + "img/account_wallet.ec049a00.svg";